import { setAttr } from '../../../scripts/utils/setAttr';

const tabControls = document.querySelectorAll(
  '[data-pro-multifamily-installation-support-tab-control]'
);

export const activateTabs = () => {
  tabControls.forEach((tabControl) => {
    tabControl.addEventListener('click', () => {
      const key = tabControl.getAttribute(
        'data-pro-multifamily-installation-support-tab-control'
      );

      setAttr(
        key,
        'data-active',
        '[data-pro-multifamily-installation-support]',
        tabControl
      );
    });
  });
};
